export default {
	QueryDoCity: "/foundation/dict/api/FnDictionary/Query",//获取省份或城市
//  QueryDoCity: "/api/FnDictionary/Query",//获取省份或城市
//  QueryDoCity: "/api/services/foundation/FnDictionaryValViewService/QueryDoCity",//获取省份或城市
    GetMeetingTypes: "/api/services/tenantx/TtProposalService/GetMeetingTypes",//获取会议类型  
    QueryAddresses: "/api/services/external/MeiCanService/QueryAddresses", //获取送餐地点
    QueryTimelist: "/api/services/external/MeiCanService/QueryTimelist",//获取送餐时间点
    // GetOpenMealUrl: "/api/services/external/ShopService/GetOpenMealUrl",//获取餐厅站地址,旧地址
    GetOpenMealUrl: "/api/Meal/Meal/GetOpenMealUrl",//获取餐厅站地址
    getMenu: "/api/services/external/MeiCanService/QueryShops",//获取餐厅详情
    IndexConfig: "/api/resource/shop/Config/Get",//获取首页配置
    GetOrderUrl: "/api/category/meal/MeiTuan/GetOrderUrl",//获取外部站点url
    getMe: "/foundation/passport/IUserService/GetMe", //获取用户信息
    rest: '/api/external/syt/smartmice/rest', //获取商宴通接口
    meiTuanLogin:'/api/category/meal/meituan/shop/login',// 美团到餐地址
    saveCacheData:'/api/statestore/redis/create',// 数据持久化保存
    
}


// WEBPACK FOOTER //
// ./src/api/api.js